import { Component, Input, ElementRef, SimpleChanges, OnChanges } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ConfigService } from './../../../services/config/config.service';
import { SetComponentsService } from '../../../services/edit/set-components.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';

@Component({
  selector: 'edit-c-image',
  templateUrl: './edit-c-image.component.html',
  styleUrls: ['./edit-c-image.component.scss'],
})
export class EditCImageComponent extends SidenavContent implements OnChanges {
  @Input() template: any;
  @Input() rowType: any;
  @Input() rowArray: any;
  @Input() compArray: any;
  @Input() image: any;
  @Input() edit: boolean;
  @Input() defaultColors: any = true;
  @Input() starterTheme = '';

  isCollapsed = true;
  fileUploadCheck = false;
  selectedFile: File | null = null;
  isUploading = false;

  // Form Variables
  typeOf: string;
  title: string;
  imgTitle: string;
  background = '';
  color = '';
  flushed: boolean;
  imgUrl = '';
  className = '';
  display: string;
  align = 'center';
  maxHeight: string;
  height = 'auto';
  maxWidth = '100%';
  width: string;
  radius: string;
  border: string;
  filter: string;
  transform: string;
  opacity: number;
  alt: string;
  longdesc: string;
  marginLeft: string;
  marginRight: string;
  paddingTop: string;
  paddingBottom: string;
  targetUrl = '';

  private _temp: any;
  private _OneColumn: boolean;
  private _TwoColumns: boolean;
  private _ThreeColumns: boolean;
  private _FourColumns: boolean;
  private _FiveColumns: boolean;
  private _SixColumns: boolean;
  private _uploadImageUri: string = this._configService.expressApi + '/file/upload';

  constructor(
    private _el: ElementRef,
    private _http: HttpClient,
    private _snackBar: MatSnackBar,
    private _editService: SetComponentsService,
    private _configService: ConfigService,
    private _layoutService: LayoutService,
  ) {
    super(_layoutService);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.template) {
      this._temp = changes.template.currentValue;
      this.template = this._temp;
    }
    if (changes.rowType) {
      this.rowType = changes.rowType.currentValue;
    }
    if (changes.rowArray) {
      this.rowArray = changes.rowArray.currentValue;
    }
    if (changes.compArray) {
      this.compArray = changes.compArray.currentValue;
    }
    if (changes.edit) {
      this.edit = changes.edit.currentValue;
    }
    // check Input() edit to pass in variables or set new variables.
    if (this.edit === true) {
      this.setRowType();
      this.getFormVariables();
      this.fileUploadCheck = true;
    } else {
      this.setNewVariables();
    }

    if (changes.starterTheme) {
      this.starterTheme = changes.starterTheme.currentValue;
    }

    if (!this.edit && this.template && this.starterTheme !== '' && this.starterTheme) {
      if (changes.defaultColors) {
        this.defaultColors = changes.defaultColors.currentValue;
        if (this.defaultColors) {
          this.color = this.defaultColors.fontColor;
          this.background = this.defaultColors.backColor;
        }
      }
    }
  }

  setNewVariableValues() {
    this.title = '';
    this.imgTitle = '';
    this.background = '';
    this.color = '';
    this.flushed = true;
    this.imgUrl = '';
    this.className = '';
    this.display = '';
    this.align = 'center';
    this.height = '';
    this.maxWidth = '';
    this.width = '';
    this.marginLeft = '';
    this.marginRight = '';
    this.paddingTop = '';
    this.paddingBottom = '';
    this.radius = '';
    this.border = '';
    this.filter = '';
    this.transform = '';
    this.opacity = 1.0;
    this.alt = '';
    this.longdesc = '';
    this.targetUrl = '';
  }

  setNewVariables() {
    this.setNewVariableValues();
    switch (this.rowType) {
      case 'col-2':
        this.maxHeight = '250px';
        break;
      case 'col-21':
        this.maxHeight = '250px';
        break;
      case 'col-2-1-2':
        this.maxHeight = '250px';
        break;
      case 'col-2-1-3':
        this.maxHeight = '250px';
        break;
      case 'col-2-2-1':
        this.maxHeight = '250px';
        break;
      case 'col-2-3-1':
        this.maxHeight = '250px';
        break;
      case 'col-31':
        this.maxHeight = '200px';
        break;
      case 'col-3-1-1-2':
        this.maxHeight = '200px';
        break;
      case 'col-3-1-2-1':
        this.maxHeight = '200px';
        break;
      case 'col-3-2-1-1':
        this.maxHeight = '200px';
        break;
      case 'col-42':
        this.maxHeight = '200px';
        break;
      case 'col-421':
        this.maxHeight = '200px';
        break;
      case 'col-51':
        this.maxHeight = '200px';
        break;
      case 'col-632':
        this.maxHeight = '250px';
        break;
      default:
        this.maxHeight = '350px';
    }
  }
  getFormVariables() {
    // Form Variables
    this.title = this._temp[this.compArray].title;
    this.imgTitle = this._temp[this.compArray].imgTitle;
    this.background = this._temp[this.compArray].background;
    this.color = this._temp[this.compArray].color;
    this.flushed = this._temp[this.compArray].flushed;
    this.imgUrl = this._temp[this.compArray].imgUrl;
    this.className = this._temp[this.compArray].className
      ? this._temp[this.compArray].className
      : this.className;
    this.display = this._temp[this.compArray].display;
    this.align = this._temp[this.compArray].align;
    this.maxHeight = this._temp[this.compArray].maxHeight;
    this.height = this._temp[this.compArray].height;
    this.maxWidth = this._temp[this.compArray].maxWidth;
    this.width = this._temp[this.compArray].width;
    this.marginLeft = this._temp[this.compArray].marginLeft;
    this.marginRight = this._temp[this.compArray].marginRight;
    this.paddingTop = this._temp[this.compArray].paddingTop;
    this.paddingBottom = this._temp[this.compArray].paddingBottom;
    // for gettempstyles()
    this.radius = this._temp[this.compArray].radius;
    this.border = this._temp[this.compArray].border;
    this.filter = this._temp[this.compArray].filter;
    this.transform = this._temp[this.compArray].transform;
    this.opacity = this._temp[this.compArray].opacity;
    this.alt = this._temp[this.compArray].alt;
    this.longdesc = this._temp[this.compArray].longdesc;
    this.targetUrl = this._temp[this.compArray].targetUrl
      ? this._temp[this.compArray].targetUrl
      : '';
  }
  setRowType() {
    switch (this.rowType) {
      case 'col-2':
        //this.TwoColumns=true;
        this.maxHeight = '250px';
        break;
      case 'col-21':
        //this.TwoColumns=true;
        this.maxHeight = '250px';
        break;
      case 'col-2-1-2':
        //this.TwoColumns=true;
        this.maxHeight = '250px';
        break;
      case 'col-2-1-3':
        //this.TwoColumns=true;
        this.maxHeight = '250px';
        break;
      case 'col-2-2-1':
        //this.TwoColumns=true;
        this.maxHeight = '250px';
        break;
      case 'col-2-3-1':
        //this.TwoColumns=true;
        this.maxHeight = '250px';
        break;
      case 'col-31':
        //this.ThreeColumns=true;
        this.maxHeight = '200px';
        break;
      case 'col-3-1-1-2':
        //this.ThreeColumns=true;
        this.maxHeight = '200px';
        break;
      case 'col-3-1-2-1':
        //this.ThreeColumns=true;
        this.maxHeight = '200px';
        break;
      case 'col-3-2-1-1':
        //this.ThreeColumns=true;
        this.maxHeight = '200px';
        break;
      case 'col-42':
        //this.FourColumns=true;
        this.maxHeight = '200px';
        break;
      case 'col-421':
        //this.FourColumns=true;
        this.maxHeight = '200px';
        break;
      case 'col-51':
        //this.FiveColumns=true;
        this.maxHeight = '200px';
        break;
      case 'col-632':
        //this.SixColumns=true;
        this.maxHeight = '250px';
        break;
      default:
        //this.OneColumn=true;
        this.maxHeight = '350px';
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.size > 5_000_000) {
        this.openSnackBar('Image size too large — exceeded 5MB', 'ok');
        input.value = '';
        this.selectedFile = null;
        return;
      }
      this.selectedFile = file;
    }
  }

  uploadImage() {
    if (!this.selectedFile) {
      return;
    }
    this.isUploading = true;
    const formData = new FormData();
    formData.append('photo', this.selectedFile, this.selectedFile.name);
    const params = new HttpParams();
    this._http
      .post(this._uploadImageUri, formData, { params })
      .pipe(
        catchError((err: unknown) => {
          console.error('Upload image error', err);
          this.openSnackBar('Upload failed', 'ok');
          this.isUploading = false;
          return throwError(() => err);
        }),
      )
      .subscribe({
        next: (response: any) => {
          this.openSnackBar('Image uploaded', 'ok');
          this.fileUploadCheck = true;
          this.imgUrl = '/uploads/' + response.uploadname;
          this.selectedFile = null;
          this.isUploading = false;
        },
      });
  }
  getMyStyles() {
    const result = {
      color: this.title,
      display: this.display,
      height: this.height,
      width: this.width,
      'max-height': this.maxHeight,
      'max-width': this.maxWidth,
      align: this.align,
      alt: this.alt,
      border: this.border,
      filter: this.filter,
      opacity: this.opacity,
      'border-radius': this.radius,
      transform: this.transform,
      'margin-left': this.marginLeft,
      'margin-right': this.marginRight,
    };
    return result;
  }
  updateIMAGE() {
    if (this.imgUrl && /\S/.test(this.imgUrl)) {
      const result = {
        typeOf: 'image',
        title: this.title,
        imgTitle: this.imgTitle,
        background: this.background,
        imgUrl: this.imgUrl,
        color: this.color,
        flushed: this.flushed,
        className: this.className,
        display: this.display,
        align: this.align,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth,
        width: this.width,
        radius: this.radius,
        border: this.border,
        filter: this.filter,
        targetUrl: this.targetUrl ? this.targetUrl : '',
        transform: this.transform,
        opacity: this.opacity,
        alt: this.alt,
        longdesc: this.longdesc,
        marginLeft: this.marginLeft,
        marginRight: this.marginRight,
        paddingTop: this.paddingTop,
        paddingBottom: this.paddingBottom,
      };
      this._editService.setIMAGE(result, this.rowType, this._temp, this.rowArray, this.compArray);
    } else {
      const message = 'please upload an image first';
      this.openSnackBar(message, 'ok');
    }
  }
  submitIMAGE() {
    if (this.imgUrl && /\S/.test(this.imgUrl)) {
      const result = {
        typeOf: 'image',
        title: this.title,
        imgTitle: this.imgTitle,
        background: this.background,
        imgUrl: this.imgUrl,
        color: this.color,
        flushed: this.flushed,
        className: this.className,
        display: this.display,
        align: this.align,
        maxHeight: this.maxHeight,
        maxWidth: this.maxWidth,
        width: this.width,
        radius: this.radius,
        border: this.border,
        filter: this.filter,
        targetUrl: this.targetUrl ? this.targetUrl : '',
        transform: this.transform,
        opacity: this.opacity,
        alt: this.alt,
        longdesc: this.longdesc,
        marginLeft: this.marginLeft,
        marginRight: this.marginRight,
        paddingTop: this.paddingTop,
        paddingBottom: this.paddingBottom,
      };
      this._editService.setIMAGE(result, this.rowType, this._temp, this.rowArray, this.compArray);
      this.closeNav();
    } else {
      const message = 'please upload an image first';
      this.openSnackBar(message, 'ok');
    }
  }
  //   ---------------------------------------------------------------------------
  //   ------------------------------USER EXPERIENCE -----------------------------
  //   ---------------------------------------------------------------------------

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }
}
